import React from "react";
import StaffProfileCard from "../../Staff/partials/StaffProfileCard";

/**
 *
 * @param {[]} items   list of renewal items
 * @param {string} currency  subscription currency
 */
const RenewalList = ({ items, currency }) => {
	const list = items || [];
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover">
					<tbody>
						{list.map((item, index) => (
							<tr key={index}>
								<td className="inbox-small-cells">
									<div className="todo-check pull-left">{index + 1}</div>
								</td>
								<td className="view-message">
									<small className="text-muted">Subscription Date</small> <br />
									<strong>
										{Intl.DateTimeFormat("en-GB", {
											weekday: "short",
											year: "numeric",
											month: "short",
											day: "numeric"
										}).format(new Date(item.subDate))}
									</strong>
								</td>

								<td className="view-message">
									<small className="text-muted">Amount Paid</small> <br />
									<strong className="text-success">
										{currency || ""}{" "}
										{Intl.NumberFormat("en-GB").format(item.amount)}
									</strong>
								</td>
								<td className="view-message">
									<small>Renewed By</small> <br />
									<StaffProfileCard item={item.renewedBy} />
								</td>
								<td className="view-message text-right">
									{!index && (
										<>
											<small>Number of days</small> <br />
										</>
									)}
									{index === 0 ? (
										<strong>
											{item.days} {item.days < 2 ? "Day" : "Days"}
										</strong>
									) : (
										<span className="text-danger">Expired</span>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default RenewalList;
